import $ from 'jquery';
import inViewport from '../util/in-viewport';

export default {

  init() {
    this.$articleContainer = $('.article-archive__body').find('.row');
    this.$loadContainer = $('.article-archive__loader');
    this.addEvents();
    this.modifyDOM();
  },

  addEvents() {
    $(window).on('scroll', this.infiniteScroll.bind(this));
  },

  modifyDOM() {
  },

  infiniteScroll() {
    if (!this.$loadContainer || this.$loadContainer.hasClass('is-loading')) {
      return;
    }

    if (inViewport(this.$loadContainer[0], -150)) {
      this.$loadContainer.addClass('is-loading');
      const page = parseInt(this.$loadContainer.data('post-page'), 10) + 1;
      const posts = parseInt(this.$loadContainer.data('post-count'), 10);
      const postsPerPage = parseInt(this.$loadContainer.data('posts-per-page'), 10);

      $.when(this.loadPosts(page, this.$loadContainer.data('posts-per-page'))).done((response) => {
        this.$articleContainer.append(this.htmlDecode(response.content));
        this.$loadContainer.removeClass('is-loading');
        this.$loadContainer.data('post-page', page);

        if (postsPerPage * page >= posts) {
          this.$loadContainer = false;
        }
      });
    }
  },

  loadPosts(page, postsPerPage) {
    return $.ajax({
      url: window.ajax_object.ajaxurl,
      data: {
        action: 'drager_load_news_posts',
        page,
        postsPerPage,
      },
      dataType: 'json',
      method: 'POST',
    });
  },

  htmlDecode(input) {
    let e = document.createElement('div');
    e.innerHTML = input;
    return e.childNodes.length === 0 ? '' : e.childNodes[0].nodeValue;
  },
};
